import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import HeadingTextBlock from 'LuxKit/TextBlocks/HeadingTextBlock'
import Sheet from 'components/utils/Sheet'
import LuxPlusLandingCtaButtons from './LuxPlusLandingCtaButtons'

const BottomCTASheet = styled(Sheet)`
  background: linear-gradient(90deg, ${props => props.theme.palette.product.luxPlus.background} 0%, #4C82DF 100%);
  padding: ${rem(64)} ${rem(20)};

  ${mediaQueryUp.tablet} {
    padding: ${rem(64)} ${rem(20)};
  }
`

const BottomCTAContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${rem(24)};
`

const BottomCTAButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(12)};

  ${mediaQueryUp.tablet} {
    flex-direction: row;
  }
`

function LuxPlusLandingBottomCTA() {
  const intl = useIntl()

  const headingText = intl.formatMessage({
    id: 'lG7Ukbu6MA9m4Q9UIR9l',
    defaultMessage: 'Ready to travel like a VIP?',
    description: 'Heading for bottom CTA section on LuxPlus landing page',
  })
  const subheadingText = intl.formatMessage({
    id: 'n3sPwZQti_cycmmy0vNN',
    defaultMessage: 'Join thousands of members and start saving on your next escape',
    description: 'Subheading for bottom CTA section on LuxPlus landing page',
  })
  const becomeMemberLabel = intl.formatMessage({
    id: 'gOmG-993oL_TeV7rEEH6',
    defaultMessage: 'Become a member',
    description: 'Button to join LuxPlus membership on landing page bottom CTA',
  })
  const freePreviewLabel = intl.formatMessage({
    id: 'lvo3wLJLEBEDArlNqjdo',
    defaultMessage: 'Start 28-day free preview',
    description: 'Button to start free LuxPlus preview on landing page bottom CTA',
  })

  return (
    <BottomCTASheet paletteType="inverse">
      <BottomCTAContent>
        <Group direction="vertical" gap={8} horizontalAlign="center">
          <HeadingTextBlock variant="heading3" align="center">
            {headingText}
          </HeadingTextBlock>
          <BodyText variant="medium" colour="normal-contrast" align="center">
            {subheadingText}
          </BodyText>
        </Group>
        <BottomCTAButtons>
          <LuxPlusLandingCtaButtons
            becomeMemberLabel={becomeMemberLabel}
            startFreePreviewLabel={freePreviewLabel}
            gap={12}
            switchRegionLogoColour="inherit"
          />
        </BottomCTAButtons>
      </BottomCTAContent>
    </BottomCTASheet>
  )
}

export default LuxPlusLandingBottomCTA
